import {Component, ViewChild, AfterViewInit, ViewContainerRef, ComponentFactory, ComponentRef, ComponentFactoryResolver, EventEmitter} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

import {AppService} from '@api';
import {SistemaService} from '@servicios/Sistema.Service';

import {AlertaEnum, DialogoEnum} from '@mensaje/Enumeraciones/MensajeEnumeraciones.enum';
import {MensajeService} from '@mensaje/Mensaje.Service';
import {RespuestaEstatusEnum} from '@enumeraciones/Enumeraciones.enum';

import {FiltrosComponent} from '@componentes/Filtros/Filtros.component';
import {FiltroModel} from '@componentes/Filtros/Filtro.model';
import {TipoFiltroEnum} from '@componentes/Filtros/Filtros.enum';

import {Pregunta} from '@modelo/proceso/Pregunta.model';

import {PreguntaFormComponent} from './preguntaForm.component';
import {ImportarPreguntasComponent} from './layout/importarPreguntas.component';

@Component(
    {
        selector: 'pregunta',
        templateUrl: './pregunta.template.html',
        styleUrls: ['./pregunta.component.scss']
    })

export class PreguntaComponent implements AfterViewInit {
    dataTable!: Array<any>;
    SelCompetencia: any[];
    SelCriterio: any[];
    SelTipoPregunta: any[];
    SelTipoColaborador: any[];
    SelDepartamento: any[];
    SelNivel: any[];
    SelEscalaEvaluacion: any[];
    SelEvaluadores: any[];
    SelTipopregunta: any[];

    consulta!: boolean;
    @ViewChild("containerFormulario", {read: ViewContainerRef}) containerFormulario!: ViewContainerRef;

    @ViewChild(FiltrosComponent) filtrosComponent!: FiltrosComponent;
    filtrosDisplay: Array<FiltroModel> = [];
    uriApi: string

    constructor(private appService: AppService, private mensajeService: MensajeService, public sistemaService: SistemaService, public translate: TranslateService, public _cfr: ComponentFactoryResolver) {
        this.uriApi = "planeacion/pregunta/buscar";

        this.SelCompetencia = [];
        this.SelCriterio = [];
        this.SelTipoPregunta = [];
        this.SelTipoColaborador = [];
        this.SelDepartamento = [];
        this.SelNivel = [];
        this.SelEscalaEvaluacion = [];
        this.SelEvaluadores = [];
        this.SelTipopregunta = [];
        this.GenerarFiltros();
    }

    ngAfterViewInit() {
        this.SetNivelFiltro();
        this.SetCompetenciaFiltro();
        this.SetTipoPreguntaFiltro();
    }

    //Genera el filtro para las preguntas
    GenerarFiltros() {
        let filtrosDisplay: Array<FiltroModel> = [];

        filtrosDisplay.push(
            new FiltroModel(
                {
                    TipoFiltro: TipoFiltroEnum.Input,
                    Titulo: 'Clave',
                    Obligatorio: false,
                    MensajeError: "",
                    Propiedad: 'clave'
                })
        );
        filtrosDisplay.push(
            new FiltroModel(
                {
                    TipoFiltro: TipoFiltroEnum.DropDown,
                    Titulo: 'Competencia',
                    DisplayValor: 'nombre',
                    ValorName: 'competenciaid',
                    Opciones: this.SelCompetencia,
                    Propiedad: "competenciaid",
                    Obligatorio: false,
                    Buscar: true,
                    Suscripcion: new EventEmitter()
                })
        );
        filtrosDisplay.push(
            new FiltroModel(
                {
                    TipoFiltro: TipoFiltroEnum.DropDown,
                    Titulo: 'Criterio',
                    DisplayValor: 'nombre',
                    ValorName: 'criterioid',
                    Opciones: this.SelCriterio,
                    Propiedad: "criterioid",
                    Obligatorio: false,
                    Buscar: true
                })
        );
        filtrosDisplay.push(
            new FiltroModel(
                {
                    TipoFiltro: TipoFiltroEnum.DropDownMulti,
                    Valor: [],
                    Titulo: 'Nivel',
                    DisplayValor: 'nombre',
                    ValorName: 'nivelid',
                    Opciones: this.SelNivel,
                    Propiedad: "nivelid",
                    Obligatorio: false,
                    Buscar: false
                })
        );
        filtrosDisplay.push(
            new FiltroModel(
                {
                    TipoFiltro: TipoFiltroEnum.DropDown,
                    Titulo: 'Tipo pregunta',
                    DisplayValor: 'nombre',
                    ValorName: 'tipopreguntaid',
                    Opciones: this.SelTipopregunta,
                    Propiedad: "tipopreguntaid",
                    Obligatorio: false,
                    Buscar: false,
                    Suscripcion: new EventEmitter()
                })
        );
        filtrosDisplay.push(
            new FiltroModel(
                {
                    TipoFiltro: TipoFiltroEnum.DropDown,
                    Titulo: 'Escala evaluación',
                    DisplayValor: 'nombre',
                    ValorName: 'escalaevaluacionid',
                    Opciones: this.SelEscalaEvaluacion,
                    Propiedad: "escalaevaluacionid",
                    Obligatorio: false,
                    Buscar: false
                })
        );
        filtrosDisplay.push(
            new FiltroModel(
                {
                    TipoFiltro: TipoFiltroEnum.DropDown,
                    Titulo: 'Activo',
                    DisplayValor: 'nombre',
                    ValorName: 'valor',
                    Opciones: [{nombre: "Sí", valor: true}, {nombre: "No", valor: false}],
                    Propiedad: "activo",
                    Obligatorio: false,
                    Buscar: true
                })
        );

        this.filtrosDisplay = filtrosDisplay;
    }

    //Trae las nivel para el filtro de las preguntas
    SetNivelFiltro() {
        this.appService.Get("catalogo/nivel").then(res => {
            if (res.status == RespuestaEstatusEnum.Success) {
                this.SelNivel = res.data;
                let filtro = this.filtrosComponent.filtros.find(x => x.ValorName == 'nivelid');
                if (filtro) {
                    filtro.Opciones = this.SelNivel;
                }
            }
        });
    }

    //Trae las competencia para el filtro de las preguntas
    SetCompetenciaFiltro() {
        this.appService.Post("configuracion/competencia/buscar", {activo: 1}).then(res => {
            if (res.status == RespuestaEstatusEnum.Success) {
                this.SelCompetencia = res.data;
                let filtro = this.filtrosComponent.filtros.find(x => x.ValorName == 'competenciaid');
                if (filtro) {
                    filtro.Opciones = this.SelCompetencia;
                    filtro.Suscripcion.subscribe((v: number) => {
                        this.SetCriterio(v);
                    })
                }
            }
        });
    }

    //Trae los criterios dependiendo de la competencia seleccionada en el filtro de preguntas
    SetCriterio(competenciaid: number) {
        let filtro = this.filtrosComponent.filtrosSeleccionados.find(x => x.ValorName == 'criterioid');
        if (filtro) {
            filtro.Valor = null;
            if (!competenciaid) {
                this.SelCriterio = [];
                filtro.Opciones = this.SelCriterio;
                return;
            }

            this.appService.Post("configuracion/criterio/buscar", {competenciaid: competenciaid, activo: 1}).then(res => {
                if (res.status == RespuestaEstatusEnum.Success) {
                    this.SelCriterio = res.data;
                    if (filtro) {
                        filtro.Opciones = this.SelCriterio;
                    }
                }
            });
        }



    }

    SetTipoPreguntaFiltro(){
        this.appService.Get("catalogo/tipopregunta").then(res=>{
            if(res.status == RespuestaEstatusEnum.Success){
                this.SelTipopregunta = res.data;
                let filtro = this.filtrosComponent.filtros.find(x => x.ValorName == 'tipopreguntaid');
                if (filtro) {
                    filtro.Opciones = this.SelTipopregunta;
                    filtro.Suscripcion.subscribe((v: number) => {
                        this.SetEscalaEvaluacionFiltro(v);
                    })
                }
            }
        })
    }

    SetEscalaEvaluacionFiltro(valor:number){
        if(valor == 1){
            let filtro = this.filtrosComponent.filtrosSeleccionados.find(x => x.ValorName == 'escalaevaluacionid');
        if (filtro) {
            filtro.Valor = null;
            if (!valor) {
                this.SelEscalaEvaluacion = [];
                filtro.Opciones = this.SelEscalaEvaluacion;
                return;
            }
        
            this.appService.Post("configuracion/escalaevaluacion/buscar",{activo: 1}).then(res=>{
                if(res.status == RespuestaEstatusEnum.Success){
                    this.SelEscalaEvaluacion = res.data;
                    if (filtro) {
                        filtro.Opciones = this.SelEscalaEvaluacion;
                    }
                }
            })
        }
        }else{
            let filtro = this.filtrosComponent.filtrosSeleccionados.find(x => x.ValorName == 'escalaevaluacionid');
        if (filtro) {
            filtro.Valor = null;
            this.SelEscalaEvaluacion = [];
            filtro.Opciones = this.SelEscalaEvaluacion;
        }
        }
    }

    //Manda la informacion a la tabla correspondiente
    SetDatos(data: any) {
        this.dataTable = data;
    }

    //Formulario para validar que accion se va arealizar y mandar la informacion a la nueva pantalla
    Formulario(accionid: number, id: number = 0) {
        let accion: string = ""
        switch (accionid) {
            case 1:
                accion = "Agregar";
                break;
            case 2:
                accion = "Ver";
                break;
            case 3:
                accion = "Editar";
                break;
        }
        this.cargarContenedorFormulario({accionid: accionid, accion: accion, id: id});
    }

    //Carga el contenedor con la informacion de la nueva pantalla
    cargarContenedorFormulario(data: {accionid: number, accion: string, id: number}) {
        this.consulta = true;
        this.containerFormulario.clear();
        const factory: ComponentFactory<any> = this._cfr.resolveComponentFactory(PreguntaFormComponent);
        var ref: ComponentRef<any> = this.containerFormulario.createComponent(factory);
        ref.instance.accion = {accionid: data.accionid, accion: data.accion};
        ref.instance.id = data.id;
        ref.instance.output.subscribe((cambio: boolean) => {
            this.consulta = false;
            ref.destroy();
            if (cambio) {
                this.filtrosComponent.Consultar(this.filtrosComponent.filtros);
            }
        });
    }

    //Elimina la pregunta seleccionada
    Eliminar(e: Pregunta) {
        let opciones = this.sistemaService.GetOpcionesEliminar();
        this.mensajeService.Dialogo(DialogoEnum.aviso, '', '¿Estás seguro que quieres eliminar el registro? <br> Esta acción no se podra deshacer.', opciones).then(res => {
            if (res == 1) {
                this.appService.Delete("planeacion/pregunta/" + e.preguntaid).then(res => {
                    if (res.status == RespuestaEstatusEnum.Success) {
                        this.mensajeService.Alerta(AlertaEnum.Success, res.message);
                        this.filtrosComponent.Consultar(this.filtrosComponent.filtros);
                    }
                })
            }
        })
    }

    //Genera y descarga un Layout vacion de las preguntas
    DescargarLayout() {
        this.appService.PostGetFile("planeacion/pregunta/layout", {})
    }

    //Carga el contenedor con la informacion de la pantalla para importar preguntas
    cargarContenedorLayout() {
        this.consulta = true;
        this.containerFormulario.clear();
        const factory: ComponentFactory<any> = this._cfr.resolveComponentFactory(ImportarPreguntasComponent);
        var ref: ComponentRef<any> = this.containerFormulario.createComponent(factory);
        ref.instance.cerrarImportacion.subscribe((cambio: boolean) => {
            if (cambio) {
                this.filtrosComponent.Consultar(this.filtrosComponent.filtros);
            }
            this.consulta = false;
            ref.destroy();
        });
    }



}
